import { Link, router } from '@inertiajs/react'
import { Button } from '@/components/ui/button'

export default function AgentsIndex({ organization, agents = [], currentUser, flash }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto flex items-center justify-between px-4 py-4">
          <h1 className="text-xl font-bold">Live Triage</h1>
          <div className="flex items-center gap-4">
            <Link href="/dashboard"><Button variant="ghost" size="sm">Dashboard</Button></Link>
            <Link href="/admin/organization"><Button variant="ghost" size="sm">Settings</Button></Link>
            <span className="text-sm text-muted-foreground">{currentUser?.email}</span>
            <Link href="/users/sign_out" method="delete" as="button">
              <Button variant="outline" size="sm">Sign out</Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="container mx-auto max-w-4xl px-4 py-10">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <h2 className="text-2xl font-semibold tracking-tight">Agents</h2>
            <p className="text-sm text-muted-foreground">
              Each agent is a triage persona with its own prompt, avatar, voice, and intake schema.
            </p>
          </div>
          <Link href="/admin/agents/new"><Button size="sm">+ New agent</Button></Link>
        </div>

        {flash?.notice && (
          <div className="mb-4 rounded-md border border-emerald-500/20 bg-emerald-500/10 px-3 py-2 text-sm text-emerald-700">
            {flash.notice}
          </div>
        )}
        {flash?.alert && (
          <div className="mb-4 rounded-md border border-red-500/20 bg-red-500/10 px-3 py-2 text-sm text-red-700">
            {flash.alert}
          </div>
        )}

        <div className="overflow-hidden rounded-lg border bg-card">
          <table className="w-full text-sm">
            <thead className="border-b bg-muted/40">
              <tr className="text-left text-xs font-medium uppercase tracking-wide text-muted-foreground">
                <th className="px-4 py-3">Name</th>
                <th className="px-4 py-3">Model</th>
                <th className="px-4 py-3">Public URL</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {agents.map((a) => (
                <tr key={a.id} className="hover:bg-muted/30">
                  <td className="px-4 py-3 font-medium">{a.name}</td>
                  <td className="px-4 py-3 text-xs">{a.default_model}</td>
                  <td className="px-4 py-3">
                    <a href={a.public_url} target="_blank" rel="noreferrer" className="font-mono text-xs underline-offset-4 hover:underline">
                      {a.public_url}
                    </a>
                  </td>
                  <td className="px-4 py-3 text-right">
                    <Link href={`/admin/agents/${a.id}/edit`}>
                      <Button variant="outline" size="sm">Edit</Button>
                    </Link>
                    <Button
                      variant="ghost"
                      size="sm"
                      className="ml-2 text-destructive"
                      onClick={() => {
                        if (confirm(`Delete agent "${a.name}"? Conversations must be empty.`)) {
                          router.delete(`/admin/agents/${a.id}`)
                        }
                      }}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  )
}
